import md5 from "md5";

const GetCravatarUrl = (email: string) => {
  return `https://cravatar.com/avatar/${md5(email.toLowerCase().trim())}?d=identicon&s=100`;
};

export const GetAvatarUrl = (username: string, email: string) => {
  if (email) {
    return GetCravatarUrl(email);
  } else {
    return GetCravatarUrl(username + "@avatar.com");
  }
};

/**
 * 头像/图片加载失败时的兜底处理：隐藏加载失败的图片
 *
 * 用于模板中的 `@error` 事件（原写法是 `(e: any) => (e.target.style.display = "none")`，
 * 依赖 any 才能访问 target.style，这里收敛成显式类型判断）
 */
export const HandleImageError = (e: Event) => {
  const target = e.target;
  if (target instanceof HTMLElement) {
    target.style.display = "none";
  }
};
